import { render } from "./AdminWorkflowConfigPage.vue?vue&type=template&id=a88530be&scoped=true"
import script from "./AdminWorkflowConfigPage.vue?vue&type=script&lang=js"
export * from "./AdminWorkflowConfigPage.vue?vue&type=script&lang=js"

import "../forms/form.css?vue&type=style&index=0&id=a88530be&scoped=true&lang=css&external"
import "./AdminWorkflowConfigPage.vue?vue&type=style&index=1&id=a88530be&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a88530be"]])

export default __exports__